/** End-user classification for proximity / threat workflows. */
export enum EndUserType {
  Survivor = 'SURVIVOR',
  Perpetrator = 'PERPETRATOR',
}

export const END_USER_TYPE_OPTIONS: { name: string; value: EndUserType }[] = [
  { name: 'Victim', value: EndUserType.Survivor },
  { name: 'Accused', value: EndUserType.Perpetrator },
];
